<template>
  <div id="app">
    <div id="modal" class="modal">
      <div class="modal-content">
                <span class="close" v-on:click="hideModal()">&times;</span>
        <p id="modal-pid">Participant<p>
              <div class="modal-view"><img src="" id="lens-img-t"/> <span id="modal-view-t"></span></div>
              <div class="modal-view"><img src="" id="lens-img-f"/> <span id="modal-view-f"></span></div> 
              <div class="modal-view"><img src="" id="lens-img-r"/> <span id="modal-view-r"></span></div>
              <div class="modal-view"><img src="" id="lens-img-l"/> <span id="modal-view-l"></span></div>
              <div class="modal-view"><img src="" id="lens-img-d"/> <span id="modal-view-p"></span></div>
        </div>

    </div>

    <h1>Maps Around Me: 3D Multiview Layouts in Immersive Space</h1>   
    <h1>SP3. User generated layouts</h1>   
    <div class="divider"></div>
    <div class="pure-menu pure-menu-horizontal" id="sticky-menu">
      <ul class="pure-menu-list">
          <li class="pure-menu-item"><a href="#description" class="pure-menu-link">Description</a></li>
          <li class="pure-menu-item"><a href="#naive" class="pure-menu-link"><b>Naïve Layout</b></a></li>
          <li class="pure-menu-item"><a href="#search" class="pure-menu-link"><b>Search</b></a></li>
          <li class="pure-menu-item"><a href="#comparison" class="pure-menu-link"><b>Comparison</b></a></li>
          <li class="pure-menu-item"><a href="#route" class="pure-menu-link"><b>Route Planning</b></a></li>
          <li class="pure-menu-item"><a href="#general" class="pure-menu-link"><b>General Layout</b></a></li>

          <li class="pure-menu-item"><a href="#all" class="pure-menu-link">All Tasks</a></li>
      </ul>
  </div>
    <span id="description"></span>
     <h2>Description</h2>
    <div  class="description">
   
    <p>
    This web page is a suplementary material for the <a href="http://ieeevis.org/year/2020/welcome">Infovis 2020</a> paper submission number 1229. 
    This web page contains screen captures of all layouts generated by users in the observation study. The first five sections (Naïve Layout, Search, Comparison, Route Planning, General Layout) show each of the layouts generated in the specific task. The last section, All Tasks, shows how layouts of each of participants changes throughout the study in different tasks. 
    </p>
    <b>Legend</b>

    <div class="pure-g">
          <div  class="pure-u-1-2 pure-u-xl-1-2">
              <p>
              <ul style="list-style:circle">
                <li><button class="pure-button">T</button>: Top-down view</li>
                <li><button class="pure-button" >F</button>: Front view</li>
                <li><button class="pure-button" >R</button>: Right view</li>
                <li><button class="pure-button" >L</button>: Left view</li>
                <li><button class="pure-button" >I</button>: Isometric view</li>
                </ul>
              </p>
          </div>
          <div  class="pure-u-1-2 pure-u-xl-1-2">
            
            <p>
              <ul style="list-style:circle">
                <li>Each of the rectangles on the figure is a single map view.</li>
                <li>The colour hue represents a single map group.</li>
                <li>The <span style="padding:0px 5px 0px 5px;background:black; color:white">black</span> rectangle is the world map.</li>
                <li>Click the figure to see the layout in all views.</li>
               </ul>
              </p>
          </div>
          
      </div>

  
    </div>
    <hr>
    <div class="divider"></div>
     <span id="naive"></span>

    <h2>Naïve Layout</h2> 
    <p>These are the naïve layouts generated by users.</p>
    <div class="buttonlist">
      <button class="pure-button" v-on:click="showView('l','t')">T</button>
      <button class="pure-button" v-on:click="showView('l','f')">F</button>
      <button class="pure-button" v-on:click="showView('l','l')">R</button>
      <button class="pure-button" v-on:click="showView('l','r')">L</button>
      <button class="pure-button" v-on:click="showView('l','2h')">I</button>
    </div>
    <div class="pure-g" >
      <div  class="l-t pure-u-1-4 pure-u-xl-1-8 layout-top" v-for="idx1 in 16" :key="idx1">
        <LayoutComponent :pid="`${idx1}`" task="naive" view="TopDown"/>
      </div>
      <div  class="l-f pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx2 in 16" :key="idx2">
        <LayoutComponent :pid="`${idx2}`" task="naive" view="Front"/>
      </div>
      <div  class="l-l pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx3 in 16" :key="idx3">
        <LayoutComponent :pid="`${idx3}`" task="naive" view="Left"/>
      </div>
      <div class="l-r pure-u-1-4 pure-u-xl-1-8 hidden"  v-for="idx4 in 16" :key="idx4">
        <LayoutComponent :pid="`${idx4}`" task="naive" view="Right"/>
      </div>
      <div  class="l-2h pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx5 in 16" :key="idx5">
        <LayoutComponent :pid="`${idx5}`" task="naive" view="TwoHalf"/>
      </div>
    </div>

    <span id="search"></span>

    <h2>Search</h2> 
    <p>These are layouts generated by users in the search task.</p>

    <div class="buttonlist">
      <button class="pure-button" v-on:click="showView('s','t')">T</button>
      <button class="pure-button" v-on:click="showView('s','f')">F</button>
      <button class="pure-button" v-on:click="showView('s','l')">R</button>
      <button class="pure-button" v-on:click="showView('s','r')">L</button>
      <button class="pure-button" v-on:click="showView('s','2h')">I</button>
    </div>
    <div class="pure-g" >
      <div class="s-t pure-u-1-4 pure-u-xl-1-8" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="search" view="TopDown"/>
      </div>
      <div class="s-f pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="search" view="Front"/>
      </div>
      <div class="s-l pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="search" view="Left"/>
      </div>
      <div class="s-r pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="search" view="Right"/>
      </div>
      <div class="s-2h pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="search" view="TwoHalf"/>
      </div>
    </div>  

    <span id="comparison"></span>
    <h2>Comparison</h2> 
    <p>These are layouts generated by users in the visual comparison task.</p>

    <div class="buttonlist">
      <button class="pure-button" v-on:click="showView('c','t')">T</button>
      <button class="pure-button" v-on:click="showView('c','f')">F</button>
      <button class="pure-button" v-on:click="showView('c','l')">R</button>
      <button class="pure-button" v-on:click="showView('c','r')">L</button>
      <button class="pure-button" v-on:click="showView('c','2h')">I</button>
    </div>
    <div class="pure-g" >
      <div class="c-t pure-u-1-4 pure-u-xl-1-8" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="comparison" view="TopDown"/>
      </div>
      <div class="c-f pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="comparison" view="Front"/>
      </div>
      <div class="c-l pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="comparison" view="Left"/>
      </div>
      <div class="c-r pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="comparison" view="Right"/>
      </div>
      <div class="c-2h pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="comparison" view="TwoHalf"/>
      </div>
    </div>  

    <span id="route"></span>
    <h2>Route Planning</h2> 
        <p>These are layouts generated by users in the route planning.</p>

    <div class="buttonlist">
      <button class="pure-button" v-on:click="showView('p','t')">T</button>
      <button class="pure-button" v-on:click="showView('p','f')">F</button>
      <button class="pure-button" v-on:click="showView('p','l')">R</button>
      <button class="pure-button" v-on:click="showView('p','r')">L</button>
      <button class="pure-button" v-on:click="showView('p','2h')">I</button>
    </div>
    <div class="pure-g" >
      <div class="p-t pure-u-1-4 pure-u-xl-1-8" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="route" view="TopDown"/>
      </div>
      <div class="p-f pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="route" view="Front"/>
      </div>
      <div class="p-l pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="route" view="Left"/>
      </div>
      <div class="p-r pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="route" view="Right"/>
      </div>
      <div class="p-2h pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="route" view="TwoHalf"/>
      </div>
    </div>  

    <span id="general"></span>

    <h2>General Layout</h2> 
        <p>These are layouts general layouts generated by users.</p>

    <div class="buttonlist">
      <button class="pure-button" v-on:click="showView('o','t')">T</button>
      <button class="pure-button" v-on:click="showView('o','f')">F</button>
      <button class="pure-button" v-on:click="showView('o','l')">R</button>
      <button class="pure-button" v-on:click="showView('o','r')">L</button>
      <button class="pure-button" v-on:click="showView('o','2h')">I</button>
    </div>
    <div class="pure-g" >
      <div class="o-t pure-u-1-4 pure-u-xl-1-8" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="general" view="TopDown"/>
      </div>
      <div class="o-f pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="general" view="Front"/>
      </div>
      <div class="o-l pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="general" view="Left"/>
      </div>
      <div class="o-r pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="general" view="Right"/>
      </div>
      <div class="o-2h pure-u-1-4 pure-u-xl-1-8 hidden" v-for="idx in 16" :key="idx">
        <LayoutComponent :pid="`${idx}`" task="general" view="TwoHalf"/>
      </div>
    </div>   

    <span id="all"></span>

    <h2>All Tasks</h2> 
        <p>These are layouts generated by each of the users in all tasks ordered from left to right as the actual order in the study.</p>

     <div class="buttonlist">
      <button class="pure-button" v-on:click="showView('a','t')">T</button>
      <button class="pure-button" v-on:click="showView('a','f')">F</button>
      <button class="pure-button" v-on:click="showView('a','l')">R</button>
      <button class="pure-button" v-on:click="showView('a','r')">L</button>
      <button class="pure-button" v-on:click="showView('a','2h')">I</button>
    </div>
    <div class="pure-g" v-for="index in 16" :key="index">
      <div class="pure-g pure">
        <div class="a-t pure-u-1-5 "><LayoutComponent :pid="`${index}`" task="naive" tasklabel="yes" view="TopDown"/></div>

      
        <div class="a-t pure-u-1-5 "><LayoutComponent :pid="`${index}`" task="search" tasklabel="yes" view="TopDown"/></div>
    
   
        <div class="a-t pure-u-1-5 "><LayoutComponent :pid="`${index}`" task="comparison" tasklabel="yes" view="TopDown"/></div>
     

  
       <div class="a-t pure-u-1-5"><LayoutComponent :pid="`${index}`" task="route" tasklabel="yes" view="TopDown"/></div>
 
     
   
       <div class="a-t pure-u-1-5 "><LayoutComponent :pid="`${index}`" task="general" tasklabel="yes" view="TopDown"/></div>
    </div>
      <!-- end -->

    <div class="pure-g pure">
      <div class="a-f pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="naive" tasklabel="yes" view="Front"/></div>
    
      <div class="a-f pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="search" tasklabel="yes" view="Front"/></div>
      
      <div class="a-f pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="comparison" tasklabel="yes" view="Front"/></div>
   
      <div class="a-f pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="route" tasklabel="yes" view="Front"/></div>
  
      <div class="a-f pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="general" tasklabel="yes" view="Front"/></div> 
    </div>

     <div class="pure-g pure">
      <div class="a-l pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="naive" tasklabel="yes" view="Left"/></div>
    
      <div class="a-l pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="search" tasklabel="yes" view="Left"/></div>
  
      <div class="a-l pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="comparison" tasklabel="yes" view="Left"/></div>
 
      <div class="a-l pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="route" tasklabel="yes" view="Left"/></div>
  
      <div class="a-l pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="general" tasklabel="yes" view="Left"/></div> 
    </div>

    <div class="pure-g pure">
      <div class="a-r pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="naive" tasklabel="yes" view="Right"/></div>
   
      <div class="a-r pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="search" tasklabel="yes" view="Right"/></div>
  
      <div class="a-r pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="comparison" tasklabel="yes" view="Right"/></div>
   
      <div class="a-r pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="route" tasklabel="yes" view="Right"/></div>
    
      <div class="a-r pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="general" tasklabel="yes" view="Right"/></div>   
    </div>

    <div class="pure-g">
      <div class="a-2h pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="naive" tasklabel="yes" view="TwoHalf"/></div>
 
      <div class="a-2h pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="search" tasklabel="yes" view="TwoHalf"/></div>
  
      <div class="a-2h pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="comparison" tasklabel="yes" view="TwoHalf"/></div>
  
      <div class="a-2h pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="route" tasklabel="yes" view="TwoHalf"/></div>
  
      <div class="a-2h pure-u-1-5 hidden"><LayoutComponent :pid="`${index}`" task="general" tasklabel="yes" view="TwoHalf"/></div>  
    </div>

    </div>    

<div class="divider"></div>
<hr>
      <div class="footer">Created by Kadek Ananta Satriadi. Source code on <a href="https://github.com/KadekSatriadi/Maps-Around-Me-Viewer">github</a></div>

  </div>

</template>

<script>
import LayoutComponent from './components/LayoutComponent.vue'

export default {
  name: 'app',
  components: {
    LayoutComponent
  },
  methods: {
    addClass: function(id, cls){
      var x = document.getElementsByClassName(id);
      for (var i = 0; i < x.length; i++) {
        if(x[i].classList.contains(cls) == false) x[i].classList.add(cls);
      }
    },
    removeClass: function(id, cls){

      var x = document.getElementsByClassName(id);
      for (var i = 0; i < x.length; i++) {
          if(x[i].classList.contains(cls) == true) x[i].classList.remove(cls);
      }
    },
    hideModal: function(){
      var lens = document.getElementById("modal");
      lens.style.display = "none";
    },
    showView: function (p,id) {
      var hideclass = "hidden";

      this.addClass(p + "-t", hideclass);
      this.addClass(p + "-f", hideclass);
      this.addClass(p + "-l", hideclass);
      this.addClass(p + "-r", hideclass);
      this.addClass(p + "-2h", hideclass);

      this.removeClass(p + "-" +id, hideclass);
      
    }
  }
}
</script>

<style>
/* Scrollinmg */
html {
	scroll-behavior: smooth;
}

@media screen and (prefers-reduced-motion: reduce) {
	html {
		scroll-behavior: auto;
	}
}
/* [STICKY MENU] */
#sticky-menu {
  position: sticky;
  top: 0;
  width: 100%;
  background: #333;
}
#sticky-menu a {
  display: inline-block;
  color: #fff;
  padding: 10px 15px;
  text-decoration: none;
  text-align: center;
}

/* [DOES NOT MATTER] */
html, body {
  font-family: arial, sans-serif;
  padding: 0;
  margin: 0;
}
#page-header {
  background: #c6efff;
  font-weight: bold;
  font-size: 2em;
  padding: 10px;
}
#page-contents p {
  padding: 100px 0;
  background: #FFC7C7;
}
</style>
<style>
h1{
  font-size: 2.25em;
}
h2{
  font-size: 2em;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin-bottom: 60px;
}
.modal{
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}
.modal-view{
  display: inline-block;
    max-width: 200px;
    margin: 2px;
    padding:2px;
    border: 1px solid #aaa;
    text-align: center;
}
#modal-pid{
  font-size: large;
  font-weight: bold;
}
.modal-content
{
    background-color: #fefefe;
    margin: 15% auto;
    margin-top: 5%;
    padding: 20px;
    border: 1px solid #888;
    width: 1100px;
    padding-bottom: 50px;
}
.modal-content img{
  width: 100%;
  display: inline-block;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.gridcontainer {
  display: grid;
}

.pure-button{
  margin: 5px;
}
.margined{
  margin: 1px;
}
.hidden{
  display: none;
}

h1{
  font-family: 'Montserrat', sans-serif;
  font-weight: normal;

}

.megatitle{
  font-weight: bold;
  font-size: 3em;
  font-family: 'Montserrat', sans-serif;
    margin-bottom: 2em;

}

.divider{
  margin-bottom: 80px;
}

.griditem{
  display: inline-grid;
}

.buttonlist{
  margin-top: 10px;
  margin-bottom: 25px;
}

.description
{
  font-size: larger;
  text-align: left;
  width: 80%;
  margin: auto;
}

#modal-img{
  width: 100%;
}

.left-dash{
  border-left: 1.5px dashed #dddddd;
}

.right-dash{
  border-right: 1.5px dashed #dddddd;
}


.pure-g > div {
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
        }
.l-box {
    padding: 2em;
}
</style>
